import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SecurityGuardService } from './services/security-guard.service';
import { AnalyseComponent } from './components/analyse/analyse-component/analyse.component';
import { ReportComponent } from './components/reports/report-component/report.component';
import { DataSetsComponent } from './components/data-sets/data-sets.component';
import { AnnualSummaryDashboardComponent } from './components/dashboards/annual-summary/annual-summary-dashboard.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { VfmDashboardComponent } from './components/dashboards/vfm/vfm-dashboard.component';
import { BespokeDashboardComponent } from './components/dashboards/bespoke/bespoke-dashboard/bespoke-dashboard.component';

const routes: Routes = [
    { path: 'annual-summary-dashboard', component: AnnualSummaryDashboardComponent, canActivate: [SecurityGuardService] },
    { path: 'vfm-dashboard', component: VfmDashboardComponent, canActivate: [SecurityGuardService] },
    { path: 'bespoke-dashboard', component: BespokeDashboardComponent, canActivate: [SecurityGuardService] },
    { path: 'report/:id', component: ReportComponent, canActivate: [SecurityGuardService] },
    { path: 'analyse', component: AnalyseComponent, canActivate: [SecurityGuardService] },
    { path: 'data-sets', component: DataSetsComponent, canActivate: [SecurityGuardService] },
    { path: 'unauthorized', component: UnauthorizedComponent },
    { path: '**', redirectTo: 'annual-summary-dashboard' }
];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forRoot(routes)]
})
export class AppRoutingModule { }
